module.exports = __webpack_public_path__ + "static/Midnight_mobile-266d71800186651dbcc4ade820095295.webp";